import clsx from "clsx"

import { captionClasses } from "./style"
import type { CaptionProps } from "./types"

export const Caption = ({ as: As = "span", children, className, testId, numberOfLines, ...rest }: CaptionProps) => {
  return (
    <As {...rest} data-testid={testId ?? "caption"} className={clsx(captionClasses({ numberOfLines }), className)}>
      {children}
    </As>
  )
}
